export const Errors = {
	img_alt_error: 'Something went wrong loading the image...',
};
